module.exports = __webpack_public_path__ + "static/00-ad9833b30222784bf0d4e3c7ed5f17c1.jpg";